// Core atoms
export {
  audioElementAtom,
  audioInitializedAtom,
  audioLoadingAtom,
  audioPlayerErrorAtom,
  audioPlayerStateAtom,
  awaitingPlaybackAtom,
  gainNodeAtom,
  mutePreferenceAtom,
  pendingSeekPositionAtom,
  playbackAtom,
  volumePreferenceAtom,
} from './core/primaryAtoms';

// Queue atoms
export {
  activateQueueAtom,
  clearQueueAtom,
  createLoadedQueueAtom,
  queueAtom,
} from './queue/queueAtoms';

// Derived queue atoms
export {
  currentPageQueueValueAtom,
  currentPagePaginationAtom,
  pageHasPlayableAudioAtom,
  activeQueueHasMorePagesAtom,
  waitingForNextPageAtom,
  syncActiveQueueWithPageAtom,
} from './queue/derivedQueueAtoms';

// Playback control atoms
export {
  currentTimeAtom,
  durationAtom,
  formattedCurrentTimeAtom,
  formattedDurationAtom,
  hasNextTrackAtom,
  hasPreviousTrackAtom,
  isPlayingAtom,
  progressPercentAtom,
  seekPositionAtom,
  skipToNextTrackAtom,
  skipToPreviousTrackAtom,
  playbackControlAtom,
} from './playback/playbackAtoms';

// Track-related atoms
export {
  currentTrackAtom,
  currentTrackIdAtom,
  hasCurrentTrackAtom,
  playTrackAtPositionAtom,
  playTrackByIdAtom,
  playTrackFromPageQueueAtom,
  primeTrackByIdAtom,
  primeTrackFromPageQueueAtom,
  trackDurationAtomFamily,
  trackPlayingStateAtomFamily,
  trackSeekCompletionAtomFamily,
} from './player/trackAtoms';

// Tracking atoms
export { skipEventTrackingAtom } from './tracking/trackingAtoms';

// Constants
export { DEFAULT_CONTEXT } from './core/constants';

// Keyboard shortcut atoms
